import React, { useState, useMemo } from 'react';
import { Subcontractor } from '../../../types';
import { KlSheet } from '../modal/KlSheet';

export interface MobileSubcontractorPickerSheetProps {
    open: boolean;
    onClose: () => void;
    subcontractors: Subcontractor[];
    onPickSubcontractor: (sub: Subcontractor) => void;
}

export const MobileSubcontractorPickerSheet: React.FC<MobileSubcontractorPickerSheetProps> = ({
    open,
    onClose,
    subcontractors,
    onPickSubcontractor
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filtered = useMemo(() => {
        const q = searchTerm.trim().toLowerCase();
        if (!q) return subcontractors;
        return subcontractors.filter(s =>
            (s.razonSocial || '').toLowerCase().includes(q) ||
            (s.rut || '').toLowerCase().includes(q)
        );
    }, [subcontractors, searchTerm]);

    return (
        <KlSheet
            top={56}
            open={open}
            onClose={onClose}
            title="Seleccionar contratista"
            footer={
                <button
                    type="button"
                    onClick={onClose}
                    className="w-full h-11 rounded-[12px] font-bold text-sm bg-white dark:bg-slate-800 border border-[#CBD5E1] dark:border-slate-700 text-[#334155] dark:text-slate-200 active:scale-[0.98] transition-transform"
                >
                    Cancelar
                </button>
            }
        >
            <div className="flex flex-col -mx-3.5 -mt-3.5">
                {/* Buscador estilo 07 */}
                <div className="p-2.5 px-3 bg-white dark:bg-slate-900 border-b border-[#E2E8F0] dark:border-slate-800">
                    <div className="h-10 border border-[#E2E8F0] dark:border-slate-700 rounded-[10px] bg-white dark:bg-slate-800 px-3 flex items-center gap-2">
                        <svg
                            className="w-[18px] h-[18px] text-slate-400 shrink-0"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="11" cy="11" r="8" />
                            <path d="m21 21-4.3-4.3" />
                        </svg>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Buscar por RUT o razón social…"
                            className="w-full bg-transparent text-[13px] text-[#0F172A] dark:text-slate-100 placeholder:text-[#94A3B8] focus:outline-none"
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                onClick={() => setSearchTerm('')}
                                className="text-slate-400 hover:text-slate-600 p-1"
                            >
                                <span className="material-symbols-outlined text-[16px]">close</span>
                            </button>
                        )}
                    </div>
                </div>

                {/* Lista de filas de 44px estilo 07 */}
                <div className="overflow-y-auto overscroll-contain pb-6">
                    {filtered.length === 0 ? (
                        <div className="p-8 text-center text-xs text-slate-400">
                            No se encontraron empresas contratistas.
                        </div>
                    ) : (
                        filtered.map((sub) => (
                            <div
                                key={sub.id}
                                onClick={() => {
                                    onPickSubcontractor(sub);
                                    onClose();
                                }}
                                className="flex items-center gap-2.5 min-h-[44px] px-3 py-1.5 border-b border-[#F1F5F9] dark:border-slate-800 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50 active:bg-blue-50/50 cursor-pointer select-none transition-colors"
                            >
                                <span className="font-mono text-[11px] font-semibold text-[#64748B] dark:text-slate-400 shrink-0 w-24 truncate">
                                    {sub.rut || '-'}
                                </span>
                                <span className="flex-1 text-[13px] font-medium text-[#0F172A] dark:text-slate-100 truncate">
                                    {sub.razonSocial || 'Sin Razón Social'}
                                </span>
                                <svg
                                    className="w-4 h-4 text-[#94A3B8] shrink-0"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="m9 18 6-6-6-6" />
                                </svg>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </KlSheet>
    );
};
